import { Controller } from "@hotwired/stimulus";
import Sortable from "sortablejs";

/**
 * La bande de slides — le pendant atemporel des tracks vidéo : une vignette par page,
 * sélection et réordonnancement (SortableJS). Vue muette rendue SERVEUR (compositions#show+editor_strip
 * ou l'îlot compositions#show+strip) et morphée par le broadcast-signal à chaque save : le document et
 * ses mutations appartiennent à l'orchestrateur (image-composition-editor), la bande lui
 * remonte les intentions par outlet. La sélection est un état purement client : le serveur
 * ne rend aucun ring, l'orchestrateur le repose ici (markCurrent) après chaque rendu.
 *
 * Naming: "composition-editor--slides" in HTML.
 */
export default class extends Controller {
  static outlets = ["image-composition-editor"];

  static targets = ["strip"];

  connect() {
    this.sortable = new Sortable(this.stripTarget, {
      animation: 150,
      onEnd: (event) =>
        this.imageCompositionEditorOutlet.reorderSlides(event.oldIndex, event.newIndex),
    });
  }

  disconnect() {
    this.sortable?.destroy();
  }

  // Le ring de sélection, posé sur la vignette de la page courante. Rejoué après chaque
  // morph du frame : le morph ramène les classes au rendu serveur, qui n'en connaît pas.
  markCurrent(index) {
    [...this.stripTarget.children].forEach((node) => {
      node.classList.toggle("ring-2", Number(node.dataset.index) === index);
    });
  }

  add() {
    this.imageCompositionEditorOutlet.addSlide();
  }

  select(event) {
    this.imageCompositionEditorOutlet.selectSlide(this.indexFrom(event));
  }

  duplicate(event) {
    this.imageCompositionEditorOutlet.duplicateSlide(this.indexFrom(event));
  }

  remove(event) {
    this.imageCompositionEditorOutlet.removeSlide(this.indexFrom(event));
  }

  indexFrom(event) {
    return Number(event.currentTarget.closest("[data-index]").dataset.index);
  }
}
